import { Segmented, SegmentedProps } from "antd"

type Props = {
	className?: string
	onChange: (value: string | number) => void
	options: SegmentedProps["options"]
	size?: SegmentedProps["size"]
	value?: SegmentedProps["value"]
	defaultValue?: SegmentedProps["defaultValue"]
}

export const SegmentedWithoutBg = ({ className = "", onChange, options, size, value, defaultValue }: Props) => {
	return (
		<Segmented
			className={className}
			onChange={onChange}
			options={options}
			size={size}
			value={value}
			defaultValue={defaultValue}
		/>
	)
}
